import { render, staticRenderFns } from "./IphoneIcon.vue?vue&type=template&id=2b8b94c2&"
import script from "./IphoneIcon.vue?vue&type=script&lang=js&"
export * from "./IphoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports